import React, { useState } from "react";

import { Link } from "react-router-dom";

import { Row } from "react-bootstrap";

import Icon from "components/Icons/Icon";

import { withT } from "services/translation/";

import NotificationList from "./NotificationList/";
import AddRule from "./AddRule/";

function ManageNotifications({ origin, site, onBackToOverview, t }) {
  const [view, setView] = useState("notification-list");

  const content =
    view === "notification-list" ? (
      <NotificationList
        origin={origin}
        site={site}
        onChangeView={() => {
          setView("add-rule");
        }}
      />
    ) : (
      <AddRule
        origin={origin}
        site={site}
        onChangeView={() => {
          setView("notification-list");
        }}
      />
    );

  return (
    <>
      <Row className="px-2 mt-2">
        <div className="btn btn-default border-none side-pane-back text-dark">
          <Link to="#" onClick={onBackToOverview}>
            <span className="back-to-overview"><Icon className="fas fa-chevron-left mr-2" /> {t("back_to_overview")}</span>
          </Link>
        </div>
      </Row>

      <div className="row px-2">
        <div className="col-md-12">{content}</div>
      </div>
    </>
  );
}
export default withT(
  ManageNotifications,
  "site_overview.side_pane.manage_notifications"
);
